export const dealerOfferedSolutionData = {
  buttons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No',
      id: 'no',
    },
  ],
  title: 'Has the dealer offered to repair or replace the car?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/6b5623c52027-toolicontyre.jpg',
  },
}
